import { useState } from "react";
import { getBaseUrlParams } from "../utils/getBaseUrlParams";
import { showToast } from "../utils/showToast";

export default function useUploadXlsx(api) {
  const [error, setError] = useState("");
  const [file, setFile] = useState("");

  const onFileUpload = (e) => {
    let file = e.target.files[0];

    if (
      file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      file.type !== "application/vnd.ms-excel"
    ) {
      setError("Please select correct file type.");
      setFile("");
    } else {
      setError("");
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadstart = () => setFile("");
      reader.onload = () => setFile(reader.result);
    }
  };

  const request = async () => {
    try {
      const { organization_id, short_url } = getBaseUrlParams();

      let res = await api({ organization_id, short_url, file });
      showToast(res.data.message);
    } catch (err) {
      showToast(err.response.error);
      console.log(err);
    }
  };

  const reset = () => {
    setFile("");
    setError(false);
  };

  return { error, file, onFileUpload, request, reset };
}
